import { render, staticRenderFns } from "./expensesRow.vue?vue&type=template&id=4c3180d2&scoped=true&"
import script from "./expensesRow.vue?vue&type=script&lang=js&"
export * from "./expensesRow.vue?vue&type=script&lang=js&"
import style0 from "./expensesRow.vue?vue&type=style&index=0&id=4c3180d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3180d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
